"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Safety() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const phases = [{
    index: "01",
    label: "EVALUACIÓN",
    title: "EVALUACIÓN DE RIESGOS",
    accentWord: "RIESGOS",
    description: "Realizamos un análisis exhaustivo de cada sitio de trabajo antes de iniciar cualquier labor. Identificamos peligros potenciales para garantizar un entorno seguro para nuestro equipo y clientes.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/safety_assessment.webp",
    alt: "Evaluación de seguridad en sitio de construcción"
  }, {
    index: "02",
    label: "PROTOCOLO",
    title: "PROTOCOLO DE SEGURIDAD",
    accentWord: "SEGURIDAD",
    description: "Implementamos estándares estrictos de protección personal y operativa. Cada trabajador sigue protocolos rigurosos para prevenir incidentes y mantener la integridad estructural.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/safety_protocol.png",
    alt: "Equipo de construcción usando equipo de protección"
  }, {
    index: "03",
    label: "CAPACITACIÓN",
    title: "CAPACITACIÓN CONTINUA",
    accentWord: "CONTINUA",
    description: "Nuestro personal recibe formación constante sobre las últimas normativas de seguridad en Vancouver. La educación es la base de nuestra cultura de trabajo responsable.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/safety_training.png",
    alt: "Sesión de capacitación de seguridad en obra"
  }, {
    index: "04",
    label: "CUMPLIMIENTO",
    title: "CUMPLIMIENTO NORMATIVO",
    accentWord: "NORMATIVO",
    description: "Operamos bajo las regulaciones de WorkSafeBC, asegurando que cada proyecto cumpla con los más altos estándares legales y de calidad en la industria de la construcción.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/safety_compliance.png",
    alt: "Documentación de cumplimiento de seguridad"
  }];
  return;
}
function PhaseRow({
  phase,
  imageRight,
  dataIndex
}: {
  phase: {
    index: string;
    label: string;
    title: string;
    accentWord: string;
    description: string;
    image: string;
    alt: string;
  };
  imageRight: boolean;
  dataIndex: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const titleParts = phase.title.split(phase.accentWord);
  return <div data-index={dataIndex} ref={ref} className={`group relative border-t border-[#E5E7EB] py-16 md:py-24 transition-all duration-[520ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div aria-hidden="true" className="absolute left-0 top-0 h-full w-0 bg-[#E21C21] transition-all duration-[240ms] ease-out group-hover:w-1" />

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
        <div className={`order-2 md:col-span-8 ${imageRight ? "md:order-1" : "md:order-2"}`}>
          <div className="text-[#E21C21] text-xs mb-6 uppercase" style={{
          fontFamily: "JetBrains Mono, monospace",
          letterSpacing: "0.22em"
        }}>
            {phase.index} — {phase.label}
          </div>

          <h3 className="font-bold uppercase" style={{
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: "clamp(1.75rem, 3vw, 2.75rem)",
          lineHeight: 0.96,
          letterSpacing: "0em"
        }}>
            {titleParts[0]}
            <span className="text-[#E21C21] italic">{phase.accentWord}</span>
            {titleParts[1]}
          </h3>

          <div className="mt-6 h-1 w-12 bg-[#E21C21]" aria-hidden="true" />

          <p className="mt-8 text-[#666666] max-w-xl" style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em"
        }}>
            {phase.description}
          </p>

          <div className="mt-10">
            <Link to="/ContactPage" className="inline-block">
              <Button variant="link" className="text-[#E21C21] hover:no-underline p-0 h-auto uppercase font-medium" style={{
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "0.8125rem",
              letterSpacing: "0.18em"
            }}>
                <span className="relative inline-flex items-center gap-3">
                  <span className="relative">
                    CONTACTAR AHORA
                    <span aria-hidden="true" className="absolute left-0 -bottom-2 h-0.5 w-full bg-[#E21C21] transition-all duration-200 ease-out group-hover:w-[calc(100%+1rem)]" />
                  </span>
                  <ArrowRight className="size-4 transition-transform duration-200 ease-out group-hover:translate-x-1.5" />
                </span>
              </Button>
            </Link>
          </div>
        </div>

        <div className={`order-1 md:col-span-4 ${imageRight ? "md:order-2" : "md:order-1"}`}>
          <div className="relative border border-[#E5E7EB] p-2">
            <div className="relative border border-[#E21C21] p-0">
              <div className="aspect-[4/5] w-full overflow-hidden">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}